import React from "react";
import "./app.scss";
import AppRoutes from "routes";

function App() {
  return <AppRoutes />;
}

export default App;
